import { render } from "./detailCard.vue?vue&type=template&id=28d25159&scoped=true"
import script from "./detailCard.vue?vue&type=script&lang=js"
export * from "./detailCard.vue?vue&type=script&lang=js"

import "./detailCard.vue?vue&type=style&index=0&id=28d25159&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d25159"]])

export default __exports__